import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router';
import BenefitCard from './BenefitCards';
import { stateComponentComplete } from '../../../models';
import { sendDataLayer } from '../../../helpers';

const ContentTwo = () => {
const location = useLocation();
const [render, setRender] = useState<stateComponentComplete>({ ready: false });
const [currentIndex, setCurrentIndex] = useState(0);
const scrollRef = useRef<HTMLDivElement>(null);
const [isMobile, setIsMobile] = useState(false);

    const benefits = [
        { 
            icon: '/assets/estilo_vida.webp', 
            title: 'Estilo de Vida', 
            benefits: [
                { highlight: '• Precios preferenciales', text: ' en la Europea.' },
                { highlight: '• Beneficios en Cinépolis', text: ' (VIP, IMAX, 4DX).' },
                { highlight: '• Tratamientos y masajes', text: ' con Scape.' },
            ]
        },
        { 
            icon: '/assets/corazon.webp', 
            title: 'Salud', 
            benefits: [
                { highlight: '• Descuentos en fisioterapia', text: ' con Revory' },
                { highlight: '• Consultas médicas', text: ' con Midoconline.' },
                { highlight: '• Medicamento a domicilio', text: ' en Angela Care.' },
            ]
        },
        { 
            icon: '/assets/fly.webp', 
            title: 'Viajes', 
            benefits: [
                { highlight: '• Tarifas especiales', text: ' en Turismo Misión para viajes y cruceros.' },
                { highlight: '• Descuentos exclusivos', text: ' en Hoteles.' },
            ]
        },
        { 
            icon: '/assets/pet.webp', 
            title: 'Mascotas', 
            benefits: [
                { highlight: '• Precios preferenciales', text: ' en alimento con Tailwag.' },
                { highlight: '• Compra online', text: ' con envío rápido.' },
            ]
        },
    ];

    const extendedBenefits = [benefits[benefits.length - 1], ...benefits, benefits[0]];

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 599);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (render.ready) sendDataLayer('onload-pager', location.pathname);
        setRender({ ready: true });

        const initScroll = () => {
        if (scrollRef.current) {
            const width = scrollRef.current.offsetWidth;
            if (width > 0) {
            scrollRef.current.scrollLeft = width; 
            } else {
            requestAnimationFrame(initScroll);
            }
        }
        };

        if (isMobile) requestAnimationFrame(initScroll);
    }, [location.pathname, render.ready, isMobile]);

    // const isAndroid = /Android/i.test(navigator.userAgent);
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    // const handleScroll = () => {
    //     if (!scrollRef.current) return;
    //     const width = scrollRef.current.offsetWidth;
    //     const total = extendedBenefits.length;
    //     const scrollLeft = scrollRef.current.scrollLeft;
    //     const index = Math.round(scrollLeft / width);

    //     setCurrentIndex((index - 1 + benefits.length) % benefits.length);

    //     // Android fix: evitar temblor al pasar del primer clone
    //     if ((isAndroid || isIOS) && index === 0 && scrollRef.current) {
    //     setTimeout(() => {
    //         scrollRef.current!.style.scrollBehavior = 'auto';
    //         scrollRef.current!.scrollLeft = width * (total - 2);
    //         scrollRef.current!.style.scrollBehavior = 'smooth';
    //     }, 150);
    //     }

    //     // Último clone: vuelve al primer elemento
    //     if ((isAndroid || isIOS) && index === total - 1 && scrollRef.current) {
    //     setTimeout(() => {
    //         scrollRef.current!.style.scrollBehavior = 'auto';
    //         scrollRef.current!.scrollLeft = width;
    //         scrollRef.current!.style.scrollBehavior = 'smooth';
    //     }, 150);
    //     }
    // };

    const handleScroll = () => {
        if (!scrollRef.current) return;
        const width = scrollRef.current.offsetWidth;
        const total = extendedBenefits.length;
        const scrollLeft = scrollRef.current.scrollLeft;
        const index = Math.round(scrollLeft / width);
    
        setCurrentIndex((index - 1 + benefits.length) % benefits.length);
    
        const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
        const isAndroid = /Android/i.test(ua);
        const isIOS = /iPad|iPhone|iPod/.test(ua);
    
        if ((isAndroid || isIOS) && scrollRef.current) {
            
            if (index === 0) {
                scrollRef.current.style.scrollBehavior = 'auto';
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        scrollRef.current!.scrollLeft = width * (total - 2);
                        scrollRef.current!.style.scrollBehavior = 'smooth';
                    }, 20);
                });
            }

            if (index === total - 1) {
                scrollRef.current.style.scrollBehavior = 'auto';
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        scrollRef.current!.scrollLeft = width;
                        scrollRef.current!.style.scrollBehavior = 'smooth';
                    }, 20);
                });
            }
        }
    };    

    const scrollToIndex = (index: number) => {
        if (!scrollRef.current) return;
        const width = scrollRef.current.offsetWidth;
        scrollRef.current.scrollTo({ left: width * (index + 1), behavior: 'smooth' });
    };

    return (
        <main className='container_content_two'>
        <section className='container_cards'>
            <h1 className='title_container'>¿Qué encontrarás en Soy+?</h1>

            {isMobile ? (
            <>
                {/* Mobile carrusel */}
                <div
                className="carousel_scroll-wrapper mobile"
                ref={scrollRef}
                onScroll={handleScroll}
                style={{
                    overflowX: 'auto',
                    display: 'flex',
                    scrollSnapType: 'x mandatory',
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                }}
                >
                {extendedBenefits.map((item, index) => (
                    <div
                    className="carousel_scroll carousel_slide"
                    key={index}
                    style={{ flex: '0 0 100%', scrollSnapAlign: 'start' }}
                    >
                    <BenefitCard {...item} textAlign='left' />
                    </div>
                ))}
                </div>

                {/* Dots */}
                <div className='carousel_dots'>
                {benefits.map((_, idx) => (
                    <span
                    key={idx}
                    className={`dot ${currentIndex === idx ? 'active' : ''}`}
                    onClick={() => scrollToIndex(idx)}
                    />
                ))}
                </div>
            </>
            ) : (
            // Desktop: grid simple
            <div className='cards_grid desktop'>
                {benefits.map((item, index) => (
                <BenefitCard key={index} {...item} textAlign='left' />
                ))}
            </div>
            )}
        </section>
        </main>
    );
};

export default ContentTwo;
